import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagPortalHowDoIMakeABookingPage } from 'src/app/model/page/group/iag-portal/iag-portal-how-do-i-make-a-booking-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-how-do-i-make-a-booking-page',
  templateUrl: './iag-portal-how-do-i-make-a-booking-page.component.html',
  styleUrls: ['./iag-portal-how-do-i-make-a-booking-page.component.scss']
})
export class IagPortalHowDoIMakeABookingPageComponent implements OnInit {
  pageName = 'How do I make a booking?';

  iagPortalHowDoIMakeABookingPage: IagPortalHowDoIMakeABookingPage = {} as IagPortalHowDoIMakeABookingPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-make-booking') {
        this.iagPortalHowDoIMakeABookingPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagPortalHowDoIMakeABookingPage.makingBookingSection = [];
    this.iagPortalHowDoIMakeABookingPage.shoppingSearchSection = [];
    this.iagPortalHowDoIMakeABookingPage.fareTypesSection = [];
    this.iagPortalHowDoIMakeABookingPage.offersSection = [];
    this.iagPortalHowDoIMakeABookingPage.detailsSection = [];
    this.iagPortalHowDoIMakeABookingPage.expandImageSection = [];
    this.iagPortalHowDoIMakeABookingPage.sections = [];
    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentResponse(query).then((resIncludes) => {
      this.mapBanner(resIncludes.includes.Entry);
      this.sharedDataService.addSharedData(this.iagPortalHowDoIMakeABookingPage.banner);
      this.mapPageInfo(resIncludes.items);
      this.mapSections(resIncludes.includes.Entry);
    });
  }

  private mapBanner(iagPortalHowDoIMakeABookingPageEntries: Entry<any>[]) {
    iagPortalHowDoIMakeABookingPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    this.iagPortalHowDoIMakeABookingPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalHowDoIMakeABookingPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalHowDoIMakeABookingPage.banner.url = entry.fields?.url;
      this.iagPortalHowDoIMakeABookingPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalHowDoIMakeABookingPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalHowDoIMakeABookingPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalHowDoIMakeABookingPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
  private mapSections(iagPortalHowDoIMakeABookingPageEntries: Entry<any>[]) {
    iagPortalHowDoIMakeABookingPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
        switch (entry.fields['group']) {
          case 'making-a-booking':
            this.mapEntryToMakingBookingSection(entry);
            break;
          case 'shopping-search':
            this.mapEntryToSoppingSearchSection(entry);
            break;
          case 'fare-types':
            this.mapEntryToFareTypesSection(entry);
            break;
          case 'offers':
            this.mapEntryToOffersSection(entry);
            break;
          case 'details':
            this.mapEntryToDetailsSection(entry);
            break;
          default:
        }
      });
  }

  private mapEntryToMakingBookingSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalHowDoIMakeABookingPage.makingBookingSection.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      titleColorClass: entry.fields['sectionClass'] as string
    });
  }
  private mapEntryToSoppingSearchSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalHowDoIMakeABookingPage.shoppingSearchSection.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      titleColorClass: entry.fields['sectionClass'] as string
    });
  }
  private mapEntryToFareTypesSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalHowDoIMakeABookingPage.fareTypesSection.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      titleColorClass: entry.fields['sectionClass'] as string
    });
  }
  private mapEntryToOffersSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalHowDoIMakeABookingPage.offersSection.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      titleColorClass: entry.fields['sectionClass'] as string
    });
    // console.log('offers', this.iagPortalHowDoIMakeABookingPage.offersSection);
  }

  private mapEntryToDetailsSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalHowDoIMakeABookingPage.detailsSection.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      titleColorClass: entry.fields['sectionClass'] as string
    });
  }

  private mapEntryToSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalHowDoIMakeABookingPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry.fields['subBody'] as string,
      titleColorClass: entry.fields['sectionClass'] as string
    });
    this.iagPortalHowDoIMakeABookingPage.expandImageSection = this.iagPortalHowDoIMakeABookingPage.sections.filter((section) => section.group === 'expand-image-section');
    this.iagPortalHowDoIMakeABookingPage.expandImageSection.sort((a, b) => a.order - b.order);
  }
}
